var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCadenas1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34.6 34.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_10);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_10-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_10-3);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_10-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    x1: 955.38,
    y1: -261.05,
    x2: 989.98,
    y2: -261.05,
    gradientTransform: "translate(-956.26 275.06) rotate(0.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7db828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-2",
    x1: 10.96,
    y1: 16.08,
    x2: 22.73,
    y2: 16.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-3",
    x1: 16.18,
    y1: 19.11,
    x2: 17.71,
    y2: 19.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-4",
    x1: 59.13,
    y1: 16.08,
    x2: 47.36,
    y2: 16.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 70.09, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.24,34.6A17.3,17.3,0,1,1,34.6,17.36,17.32,17.32,0,0,1,17.24,34.6ZM17.36.55A16.75,16.75,0,1,0,34.05,17.36,16.77,16.77,0,0,0,17.36.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.72,15.72c0-1.09-.33-1.43-1.43-1.43H13.75c-.26,0-.51,0-.79,0,0-.75,0-1.41,0-2.08a3.89,3.89,0,0,1,3.61-3.71,4,4,0,0,1,3.91,2.47c.05.13.09.26.13.39h.57c0-.16-.09-.32-.14-.47a4.46,4.46,0,0,0-4.68-2.92,4.41,4.41,0,0,0-4,4.24c0,.67,0,1.33,0,2-1.3.28-1.44.46-1.44,1.72,0,2.31,0,4.62,0,6.94,0,1,.36,1.38,1.41,1.38h8.94c1.07,0,1.41-.35,1.41-1.45C22.73,20.43,22.73,18.08,22.72,15.72Zm-.54,7.16c0,.61-.25.82-.85.82h-9c-.61,0-.83-.25-.83-.84q0-3.6,0-7.2c0-.61.26-.83.85-.82,1.49,0,3,0,4.47,0s3,0,4.53,0c.61,0,.83.24.83.84Q22.15,19.28,22.18,22.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17,17.71a.77.77,0,0,0-.77.76.78.78,0,0,0,.51.72v1.32h.57V19.17a.78.78,0,0,0,.45-.7A.76.76,0,0,0,17,17.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11,15.72c0-1.09.33-1.43,1.43-1.43h7.54c.26,0,.51,0,.8,0,0-.75,0-1.41,0-2.08a3.89,3.89,0,0,0-3.61-3.71,4,4,0,0,0-3.91,2.47c0,.13-.09.26-.13.39H12.5c0-.16.09-.32.14-.47a4.46,4.46,0,0,1,4.68-2.92,4.41,4.41,0,0,1,4,4.24c0,.67,0,1.33,0,2,1.3.28,1.44.46,1.44,1.72,0,2.31,0,4.62,0,6.94,0,1-.36,1.38-1.41,1.38H12.37c-1.07,0-1.41-.35-1.41-1.45C11,20.43,11,18.08,11,15.72Zm.54,7.16c0,.61.25.82.85.82h9c.61,0,.83-.25.83-.84q0-3.6,0-7.2c0-.61-.25-.83-.85-.82-1.49,0-3,0-4.47,0s-3,0-4.53,0c-.61,0-.83.24-.83.84Q11.53,19.28,11.5,22.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadenas1);
export default __webpack_public_path__ + "static/media/cadenas 1.458f52bf6a6b38e3af9497d5aa34b623.svg";
export { ForwardRef as ReactComponent };